/*
 * Copyright (c) 2017-2021. Code réalisé par IpsoSenso.
 */

import 'whatwg-fetch'

const defaultFetchUser = (token) =>
	fetch(`${process.env.REACT_APP_SERVER_URL}/auth/user`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json; charset=utf-8',
			Authorization: token
		}
	})
		.then(response => {
			if (response.ok) {
				return response.json()
			}
			return
		})

const defaultRefresh = (token) =>
	fetch(`${process.env.REACT_APP_SERVER_URL}/auth/refresh`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json; charset=utf-8',
			Authorization: token
		}
	})
		.then(response => {
			if (response.ok) {
				return response.json()
			}
			return
		})

const defaultLogin = (data) => {
	const { login: username, password, rememberMe } = data
	return fetch(`${process.env.REACT_APP_SERVER_URL}/auth/login`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			username,
			password,
			rememberMe
		})
	})
		.then(response => {
			if (response.ok) {
				return response.json()
			}
			return
		})
}

let customLogin
let customFetchUser
let customRefresh


/**
 * Login de base
 *
 * Peut être surchargé en utilisant la méthode configureAuthApi.
 *
 * @param args
 * @returns {Promise<?>}
 */
export const login = (...args) => (customLogin || defaultLogin)(...args)

/**
 * Récupération de base pour l'utilisateur connecté
 *
 * Peut être surchargé en utilisant la méthode configureAuthApi.
 *
 * @param args
 * @returns {Promise<?>}
 */
export const fetchUser = (...args) => (customFetchUser || defaultFetchUser)(...args)

/**
 * Refresh de base pour les utilisateurs connectés
 *
 * Peut être surchargé en utilisant la méthode configureAuthApi.
 *
 * @param args
 * @returns {Promise<?>}
 */
export const refresh = (...args) => (customRefresh || defaultRefresh)(...args)


/**
 * Login via google
 *
 */
export function loginGoogle(data) {
	return fetch(`${process.env.REACT_APP_SERVER_URL}/configuration/loginTech`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	})
		.then(response => {
			if (response.ok) {
				return response.json()
			} else if (response.status === 400) {
				return Promise.all([response, response.json()])
			} else {
				throw response
			}
		})
}

// Gestion du storage in app
let saveUserInStorage
let removeUserInStorage
let getUserInStorage
/**
 * Possibilité de surcharger le storage par défaut
 * @param mode
 */
const STORAGE_MODE = {
	LOCAL: 'local',
	SESSION: 'session'
}
export const configureStorageMode = (mode = STORAGE_MODE.LOCAL) => {
	if (mode === STORAGE_MODE.SESSION) {
		saveUserInStorage = ({ token }) => sessionStorage.setItem('token', token)
		removeUserInStorage = () => sessionStorage.removeItem('token')
		getUserInStorage = () => sessionStorage.getItem('token')
	} else {
		saveUserInStorage = ({ token }) => localStorage.setItem('token', token)
		removeUserInStorage = () => localStorage.removeItem('token')
		getUserInStorage = () => localStorage.getItem('token')
	}
}

export const storeLocalUser = (...args) => saveUserInStorage(...args)
export const removeLocalUser = (...args) => removeUserInStorage(...args)
export const getLocalUser = (...args) => getUserInStorage(...args)

export const storeGoogleToken = (token) => {
	localStorage.setItem('googleToken', token)
}

export const removeGoogleToken = () => {
	localStorage.removeItem('googleToken')
}
